<template>
  <div v-loading.body="loading">
    <el-row class="shop-data">
      <el-col :span="24">
        <div style="font-size: 14px;" v-if="this.dataDetails[0]">
          {{ generateCustomizeString('dataUpdatedAt') }}:{{ this.nowTime }}
        </div>
        <p style="font-size: 12px; color: red;">
          {{ generateCustomizeString('statisticsNotice') }}
        </p>
      </el-col>
      <el-col
        :span="24"
        style="margin-top: 10px; border: 1px solid #e6e6e6; border-radius: 5px;"
      >
        <el-row>
          <el-col :span="24">
            <div class="statistics-title">
              {{ generateCustomizeString('keyIndicator') }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalOrdersToday') }}</div>
            <div class="statistics-number">
              {{ this.ordersData.today_all_order_count }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalOrderYesterday') }}</div>
            <div class="statistics-number">
              {{ this.ordersData.yesterday_all_order_count }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalOrderCurrentMonth') }}</div>
            <div class="statistics-number">
              {{ this.ordersData.month_all_order_count }}
            </div>
          </el-col>
          <el-col :span="6" style="padding: 40px 0 30px 30px;">
            <div>{{ generateCustomizeString('totalOrderPrevMonth') }}</div>
            <div class="statistics-number">
              {{ this.ordersData.last_month_all_order_count }}
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" style="margin-top: 30px;">
        <el-form :inline="true" ref="searchForm" :model="searchForm">
          <el-form-item :label="generateCustomizeString('time')">
            <el-date-picker
              v-model="searchForm.dataPicker"
              size="mini"
              style="vertical-align: middle;"
              type="daterange"
              align="right"
              unlink-panels
              :range-separator="generateCustomizeString('to')"
              :start-placeholder="generateCustomizeString('startDate')"
              :end-placeholder="generateCustomizeString('endDate')"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              @click="selectDate"
              v-if="this.searchForm.dataPicker"
              >{{ generateCustomizeString('confirm') }}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="selectDate"
              v-else
              disabled
              >{{ generateCustomizeString('confirm') }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" style="margin-top: 10px; padding-top: 10px;">
        <div id="app" class="shop-chart">
          <div style="font-size: 16px; font-weight: bold;">
            {{ generateCustomizeString('trend') }}
          </div>
          <ve-line :data="chartData" :settings="chartSettings"></ve-line>
        </div>
      </el-col>
      <el-col style="padding: 50px 0 10px 30px;">
        <div style="font-size: 16px; font-weight: bold;">
          {{ generateCustomizeString('detailData') }}
          <el-button
            @click="handleExport"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_btn_disable"
            size="mini"
          >
            {{ generateCustomizeString('exportCurrentData') }}</el-button
          >
          <el-button
            @click="handleExportAll"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_all_btn_disable"
            size="mini"
          >
            {{ generateCustomizeString('exportAllData') }}</el-button
          >
        </div>
      </el-col>
      <el-col style="padding-bottom: 100px;">
        <el-table :data="dataDetails" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="time" :label="generateCustomizeString('time')">
            <template slot-scope="scope">
              <span>{{ scope.row.stat_date.substr(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ordersAmount"
            :label="generateCustomizeString('orderPlaced')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.all_order_count }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ordersPayment"
            :label="generateCustomizeString('orderPaid')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.order_count }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="paymentPercent"
            :label="generateCustomizeString('orderPayRate')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.paid_order_ratio }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="averagePrice"
            :label="generateCustomizeString('averageOrderValue')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.avg_order_fee | formatPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="maxPrice"
            :label="generateCustomizeString('topOrderValue')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.max_order_fee | formatPrice }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-col style="margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import VeLine from 'v-charts/lib/line'
import moment from 'moment'
import { generateCustomizeString } from '@/utils/i18n'
import downloadSCV from '@/utils/exportCSV'

const originOrderSearchFrom = {
  dataPicker: []
}

export default {
  name: 'OrdersStatistics',
  components: {
    VeLine
  },
  data() {
    return {
      is_export_btn_disable: true,
      is_export_all_btn_disable: true,
      nowTime: '',
      currentPage: 1,
      currentTotal: 0,
      pageSize: 10,
      time: '7天',
      searchForm: Object.assign({}, originOrderSearchFrom),
      loading: false,
      dataDetails: [],
      ordersData: {
        last_month_all_order_count: 0,
        month_all_order_count: 0,
        today_all_order_count: 0,
        yesterday_all_order_count: 0
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('last7Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last14Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last30Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      chartData: {
        columns: ['Date', 'Orders'],
        rows: []
      },
      chartSettings: {
        stack: { Date: ['Orders'] },
        area: true
      }
    }
  },
  methods: {
    generateCustomizeString,
    selectDate() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (this.searchForm.dataPicker.length === 2) {
            const dates = this.searchForm.dataPicker.map(date =>
              moment(date).format('YYYY-MM-DD HH:mm:ss')
            )
            params.start_date = dates[0]
            params.end_date = dates[1]
            delete params.dataPicker
          }
          console.log(params)
          this.filters = params
          this.fetchDataDetails(1)
        } else {
          console.log('data error')
        }
      })
    },
    handleExport() {
      if (this.currentTotal <= 0) {
        return
      }
      downloadSCV(this.getCSV_title, this.getCSV_content, `order_statistic`)
    },
    handleExportAll() {
      if (this.currentTotal <= 0) {
        return
      }
      this.is_export_all_btn_disable = true
      request({
        url: '/stat/history',
        method: 'get',
        params: {
          page: 1,
          page_size: this.currentTotal,
          unit: 4,
          ...this.filters
        }
      }).then(({ data }) => {
        const _data = data.map(({ stat_date, all_order_count, order_count, paid_order_ratio, avg_order_fee, max_order_fee }) => {
          return {
            stat_date: stat_date.substr(0, 10),
            all_order_count,
            order_count,
            paid_order_ratio: paid_order_ratio + '%',
            avg_order_fee: (avg_order_fee * 100) / 10000,
            max_order_fee: (max_order_fee * 100) / 10000
          }
        })
        downloadSCV(this.getCSV_title, _data, `all_order_statistic`)
        this.is_export_all_btn_disable = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchDataDetails(1)
    },
    handleCurrentChange(val) {
      this.fetchDataDetails(val)
    },
    fetchData() {
      request({
        url: '/stat/board/order',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          this.ordersData = data
        })
        .catch(error => {
          console.warn(error)
        })
    },
    fetchDataDetails(page) {
      this.is_export_btn_disable = true
      request({
        url: '/stat/history',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize,
          unit: 4,
          ...this.filters
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.dataDetails = data
          this.chartData.rows = []
          for (var i = 0; i < this.dataDetails.length; i++) {
            var obj = {}
            obj['Date'] = this.dataDetails[i].stat_date.substr(0, 10)
            obj['Orders'] = this.dataDetails[i].all_order_count
            this.chartData.rows.push(obj)
          }
          this.chartData.rows.reverse()
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
          this.is_export_btn_disable = false
          this.is_export_all_btn_disable = false
        })
        .catch(error => {
          console.warn(error)
        })
    }
  },
  computed: {
    getCSV_title() {
      return [
        this.generateCustomizeString('time'),
        this.generateCustomizeString('orderPlaced'),
        this.generateCustomizeString('orderPaid'),
        this.generateCustomizeString('orderPayRate'),
        this.generateCustomizeString('averageOrderValue') + '(nzd$)',
        this.generateCustomizeString('topOrderValue') + '(nzd$)'
      ]
    },
    getCSV_content() {
      return this.dataDetails.map(
        ({
          stat_date,
          all_order_count,
          order_count,
          paid_order_ratio,
          avg_order_fee,
          max_order_fee
        }) => {
          return {
            stat_date: stat_date.substr(0, 10),
            all_order_count,
            order_count,
            paid_order_ratio: paid_order_ratio + '%',
            avg_order_fee: (avg_order_fee * 100) / 10000,
            max_order_fee: (max_order_fee * 100) / 10000
          }
        }
      )
    }
  },
  created: function() {
    var date = new Date()
    this.nowTime =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' ' +
      '00:00:00'
    this.fetchData()
    this.fetchDataDetails(1)
  },
  filters: {
    formatPrice: function(value) {
      if (!value) {
        return 'NZD $0.00'
      }
      return 'NZD $' + ((value * 100) / 10000).toFixed(2).toString()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.shop-data {
  padding: 30px;
}
.statistics-title {
  padding-left: 10px;
  background-color: #f1f1f1;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.statistics {
  border-right: 1px solid #e6e6e6;
  padding: 40px 0 30px 30px;
}
.statistics-number {
  padding-right: 30px;
  line-height: 40px;
  font-size: 24px;
  text-align: right;
}
.shop-chart {
  padding: 20px 30px;
  height: 460px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
</style>
<style type="text/css">
.el-input__icon {
  line-height: 20px;
}
</style>
